
    <form [formGroup]="formEdit" >
      <mat-dialog-content>
              <mat-list>
                    <mat-list-item *ngFor="let f of appliedFilters; let i = index">
                      <div class='filterDiv'>
                        <mat-form-field class="filterName">
                          <mat-label i18n="@@filterDialog.chooseFilter">Wybierz filtr</mat-label>
                            <mat-select #filter  (selectionChange)='filterChanged(i,filter.value)'  [(value)]="appliedFilters[i].filter">
                              <mat-option *ngFor="let filter of filterName | keyvalue" [value]="filter.key">
                              {{filter.value}}</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field class="filterType">
                          <mat-label i18n="@@filterDialog.chooseFilterType">Wybierz typ</mat-label>
                            <mat-select #type (selectionChange)='typeChanged(i,type.value)' [(value)]="appliedFilters[i].type">
                              <mat-option *ngFor="let filter of filterType  | keyvalue" [value]="filter.key">
                              {{filter.value}}</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <div [ngStyle]="{'display': (appliedFilters[i].filter !== FieldType.LastEntry &&
                              appliedFilters[i].filter !== FieldType.PurchaseDate) ? 'initial' : 'none'}" >
                          <mat-form-field class="filterData">
                            <mat-label i18n="@@filterDialog.filterData">Dane</mat-label>
                            <input matInput autocomplete="off"  (input)='textChanged(i, $event.target.value)'
                            [(value)]="appliedFilters[i].args[0]">
                          </mat-form-field>
                        </div>

                        <div [ngStyle]="{'display': (appliedFilters[i].filter === FieldType.LastEntry ||
                            appliedFilters[i].filter === FieldType.PurchaseDate) ? 'initial' : 'none'}" >
                          <mat-form-field class='callendarRange'>
                              <mat-label i18n="@@filterDialog.filterDateFrom">Data(od):</mat-label>
                              <input matInput [matDatepicker]="picker"  autocomplete="off"  [(value)]="appliedFilters[i].args[0]"
                              (dateInput)='dateChanged(i, 0, $event.target.value)'>
                              <mat-datepicker-toggle matSuffix [for]="picker">
                              </mat-datepicker-toggle>
                              <mat-datepicker #picker></mat-datepicker>
                          </mat-form-field>

                          <mat-form-field class='callendarRange'>
                              <mat-label i18n="@@filterDialog.filterDateTo">Data(do):</mat-label>
                              <input matInput [matDatepicker]="picker2"  autocomplete="off"  [(value)]="appliedFilters[i].args[1]"
                              (dateInput)='dateChanged(i, 1, $event.target.value)'>
                              <mat-datepicker-toggle matSuffix [for]="picker2">
                              </mat-datepicker-toggle>
                              <mat-datepicker #picker2></mat-datepicker>
                          </mat-form-field>
                        </div>

                        <img class ="filterButton" src="/assets/remove.png" (click)="removeFilter(i)">
                      </div>
                    </mat-list-item>
              </mat-list>
              <button  (click)="addFilter()" i18n="@@filterDialog.addAnotherFilter">Dodaj kolejny filtr</button>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button  (click)="reset()" i18n="@@filterDialog.filterReset">RESET</button>
        <button  (click)="save()" i18n="@@filterDialog.filterOk">OK</button>
      </mat-dialog-actions>
    </form>
  